import { render, staticRenderFns } from "./PlotPage.vue?vue&type=template&id=52b2dba0&scoped=true"
import script from "./PlotPage.vue?vue&type=script&lang=ts"
export * from "./PlotPage.vue?vue&type=script&lang=ts"
import style0 from "./PlotPage.vue?vue&type=style&index=0&id=52b2dba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2dba0",
  null
  
)

export default component.exports